import React, { useState, useRef } from 'react'

// Deps
// import compareAsc from 'date-fns/compareAsc'

// Utils
import { openModal } from 'utils/modals'

// Partials
import { Table, TR, TD } from 'views/shared/partials/table'
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Btn from 'views/shared/partials/btn'

const ProductStockList = ({ stockInfo, userStore, internetStore, ...props}) => {
	const currentPage = useRef(1);

	const calculateDistance = (coor1, coor2) => {
		const x = coor2.x - coor1.x;
		const y = coor2.y - coor1.y;
		return Math.sqrt((x*x) + (y*y));
	 };
	
	const parseStock = (page = 1, search = '') => {

		let filteredStock = (search && search.length > 0) ? stockInfo.filter((stock) => {
			let found = false;

			if(stock.group.store_code === search) { found = true }
			if(!found && stock.store_id.toString() === search) { found = true }
			if(!found && stock.group.name.toLowerCase().search(search.toLowerCase()) !== -1) { found = true; }
			if(!found && stock.group.email.toLowerCase().search(search.toLowerCase()) !== -1) { found = true; }

			return found;
		}) : stockInfo;

		// let orderedStock = filteredStock.sort
		if(userStore && userStore.group && userStore.group.latitude && userStore.group.longitude) {
			const latFloat = parseFloat(userStore.group.latitude);
			const lngFloat = parseFloat(userStore.group.longitude);

			filteredStock = filteredStock.sort((a, b) => {
				if(a.group.latitude && a.group.longitude && !(b.group.latitude && b.group.longitude)){
					return -1;
				}
				else if(!(a.group.latitude && a.group.longitude) && b.group.latitude && b.group.longitude){
					return 1;
				}
				else if(!(a.group.latitude && a.group.longitude) && !(b.group.latitude && b.group.longitude)){
					return 0;
				}
				else {
					return calculateDistance({ x: parseFloat(a.group.latitude), y: parseFloat(a.group.longitude) }, { x: latFloat, y: lngFloat }) - calculateDistance({ x: parseFloat(b.group.latitude), y: parseFloat(b.group.longitude) }, { x: latFloat, y: lngFloat })
				}
			});
		}

		currentPage.current = page;

		let paginatedStock = filteredStock.slice((page - 1) * 10, page * 10);

		return {
			stocks: paginatedStock,
			pagination: {
				current_page: page,
				last_page: Math.ceil(filteredStock.length / 10),
				per_page: 10,
				total: filteredStock.length,
			}
		}
	}

	const [data, setData] = useState(parseStock(1));

	const search = (formData) => {
		setData(parseStock(currentPage.current, formData.search_value));
	}

	const paginate = (page) => {
		setData(parseStock(page));
	}
	
	return (
		<section className="portlet productstocklist">
			<div className="portlet-header">
				<strong className="portlet-title">Mağaza Stokları</strong>

				<div className="header-controls">
					<Btn
						white small wide
						icon="map-pin"
						onClick={() => {
							openModal('order-stores-map', { top: true, stockInfo: stockInfo });
						}}>
						Haritada Gör
					</Btn>
				</div>
			</div>

			<InputForm
				ignoreEmpty
				className="portlet-filters"
				onSubmit={search}>
				<div className="filters-searchwrap">
					<FormInput
						className="lower"
						type="text"
						name="search_value"
						//onChange={(val) => { setFilters({...filters, search_value: val}) }}
						placeholder="Mağaza Kodu, İsmi, vs...">
					</FormInput>
					<button
						type="submit"
						className="searchwrap-submit">
						<i className="icon-search"></i> ara
					</button>
				</div>
			</InputForm>
			<div className="portlet-section bottom">
				<Table 
					emptyMessage="Aradığınız kriterlerde grup bulunmuyor."
					className="list-table"
					pagination={data.pagination}
					onPaginate={paginate}
					heading={
						<React.Fragment>
							<th>Mağaza Adı</th>
							<th>Stok Adedi</th>
						</React.Fragment>
					}>
					
					{data.stocks.map((stock, nth) => (
						<TR key={nth}>
							<TD mobileTitle="Mağaza:">{stock.group.name}</TD>
							<TD className="al-right" mobileTitle="Stok Adedi:">{(stock.group.id === internetStore?.group?.id) ? ((stock.stock && stock.stock > 0) ? 'Var' : 'Yok') : stock.stock}</TD>
						</TR>
					))}
				</Table>
			</div>
		</section>
	)
}

export default ProductStockList;